import { bluelightPalette } from "./bluelight";
import { bluedarkPalette } from "./bluedark";

export default function palette(mode) {
  return mode === "bluelight" ? bluelightPalette : bluedarkPalette;
}
